module.exports = __webpack_public_path__ + "img/request-confirm.b7a78ad9.png";